import { createLogic } from 'redux-logic'
import { CHANNEL_PROGRAM_OPTIONS } from '../constants/channels'
import { UNSUBSCRIBE } from '../constants/programOptions'

const unsubscribeProgramOptions = createLogic({
  type: UNSUBSCRIBE,

  process(_, dispatch, done) {
    if (global.localCable) {
      global.localCable.subscriptions.subscriptions.forEach(
        sub => sub.identifier.includes(CHANNEL_PROGRAM_OPTIONS) && sub.unsubscribe(),
      )
    }
    if (global.cloudCable) {
      global.cloudCable.subscriptions.subscriptions.forEach(
        sub => sub.identifier.includes(CHANNEL_PROGRAM_OPTIONS) && sub.unsubscribe(),
      )
    }
    done()
  },
})

export default unsubscribeProgramOptions
